<template>
  <div class="table">
    <div class="container">
      <div class="handle-box">
        <el-form :model="queryCondition" ref="queryCondition" :label-position="labelPosition" label-width="120px" class="searchForm">
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="月" prop="monthList">
                <el-select v-model="queryCondition.monthList" clearable multiple placeholder="请选择(支持多选)" style="width:100%">
                  <el-option :key="index" v-for="(item,index) in monthOptions" :label="item" :value="item"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="DC编号" prop="dcCode">
                <el-input v-model="queryCondition.dcCode" clearable placeholder="支持模糊查询" style="width:100%"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex" justify="center" align="middle">
            <el-button size="mini" @click="queryData(1)" type="primary">查询</el-button>
            <el-button size="mini" @click="onReset" type="primary">重置</el-button>
          </el-row>
        </el-form>
      </div>
      <el-row class="action-btn-row">
        <el-button size="mini" class="btn" type="primary" @click="onExport">导出</el-button>
      </el-row>
      <ux-grid ref="plxTable" :data="tableData" max-height="500" show-overflow="tooltip" highlight-current-row>
        <ux-table-column align="center" title="月" field="month"></ux-table-column>
        <ux-table-column align="center" title="DC编号" field="dcCode"></ux-table-column>
        <ux-table-column align="center" title="DC名称" field="dcName"></ux-table-column>
        <ux-table-column align="center" title="DC收货量" field="inbound"></ux-table-column>
        <ux-table-column align="center" title="更新时间" field="updateDate"></ux-table-column>
      </ux-grid>
      <div class="pagination">
        <el-pagination @size-change="pageSizeChange" @current-change="pageNumberChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import IcSelect from "@/components/common/icSelect";
import store from '@/store/index'
import DQMPApi from "@/api/DQMP/index";
import ReceiveValue from "@/api/ReceiveValue/index";
import QBRApi from "@/api/QBR/index";
import commonFunction from "@/utils/dataTableUtils";


export default {
  name: '',
  components: {
    IcSelect,
  },
  data() {
    return {
      monthOptions:[],
      showGcDialog: false,
      queryCondition: {
        monthList:[],
        dcCode: "",
        pageNum: 1,
        pageSize: 15,
      },
      category2List: [],
      category3List: [],
      tableData: [],
    }
  },
  created() {
    this.getMonth()
    this.queryData();
    this.getCategory2Lists()
    this.getCategory3Lists()
  },
  methods: {
    queryData(val) {
      if(undefined != val){
        this.queryCondition.pageNum=1
      }
      ReceiveValue.findListPage(this.queryCondition).then(res => {
        this.tableData = res.data.records;
        this.totalCount = res.data.total;
        this.pages = res.data.pages;
        this.$refs.plxTable.reloadData(res.data.records)
      });
    },
    getCategory2Lists() {
      var param = {
        categoryLevel: '2',
      }
      QBRApi.getCategoryLists(param).then(res => {
        this.categoryList2 = res.data
      });
    },
    getCategory3Lists() {
      var param = {
        categoryLevel: '3',
      }
      QBRApi.getCategoryLists(param).then(res => {
        this.categoryList3 = res.data
      });
    },
    //根据选中Category2查询Category3
    changeCategory2() {
      this.categoryList3 = []
      QBRApi.getCategoryLists({ categoryLevel: 3, category2Codes: this.queryCondition.category2CodesList }).then((res) => {
        this.categoryList3 = res.data;
      });
    },
    onReset() {
      this.$refs['queryCondition'].resetFields()
      this.queryCondition = {
        monthList:[],
        dcCode: "",
        pageNum: 1,
        pageSize: 15,
      }
      this.queryData();
    },
    onExport() {
      ReceiveValue.exportList(this.queryCondition)
    },
    getMonth(){
      DQMPApi.getMonth().then(res => {
        this.monthOptions = res
      })
    },
    pageSizeChange(val) {
      this.queryCondition.pageSize = val
      this.queryData()
    },
    pageNumberChange(val) {
      this.queryCondition.pageNum = val
      this.queryData()
    },
  },
  extends: commonFunction
}
</script>
<style scoped >
</style>
